<template>
<div>
  <md-dialog-confirm
    :md-active.sync="_showRemoveDialog"
    md-title="確認刪除"
    md-content="是否確認刪除此筆資料？"
    md-confirm-text="確認"
    md-cancel-text="取消"
    @md-cancel="$emit('close')"
    @md-confirm="$emit('confirm')">
  </md-dialog-confirm>
</div>
</template>

<script>
export default {
  props: ['showRemoveDialog'],
  data () {
    return {
    }
  },
  computed: {
    _showRemoveDialog: {
      get: function () {
        return this.showRemoveDialog
      },
      set: function (val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  components: {
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Shared/ConfirmRemove.vue